// extracted by mini-css-extract-plugin
export default {"div":"ProfileInfo_div__9DN8C","sec":"ProfileInfo_sec__fZQY-"};